import React from 'react';
import { connect } from 'react-redux';
import './styles.css';
import PopConfirm from '../../../../../../../Layout/PopConfirm';

const InstagramPopConfirm = ({ visible, authUrl, onClose }) => {
  return (
    visible && (
      <PopConfirm
        confirm="Instagram authorization opened in a new tab"
        customButtons
        popStyle={{
          width: '540px',
          maxWidth: '540px',
          paddingBottom: '32px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '230px',
        }}
        popConfirmBackgroundClick={onClose}
      >
        <p>Complete authorization, then return to this page and refresh.</p>

        <p style={{ marginBottom: '26px' }}>
          If you are not redirected, click{' '}
          <a href={authUrl} target="_blank" rel="noopener noreferrer" className="cb-integrations-pop-confirm__link">
            here
          </a>
          .
        </p>
      </PopConfirm>
    )
  );
};

const mapStateToProps = state => ({
  uuid: state.auth.uuid,
  pos_type: state.auth.pos_type,
});

export default connect(mapStateToProps, {})(InstagramPopConfirm);
